<template>
  <div
    class="card-item spore"
    style="width:50%;height: 100%;display: inline-block;"
  >
    <div class="device-picker">
      智能孢子仪
    </div>

    <div v-if="!device" class="no-data">
      暂无设备
    </div>

    <div v-else-if="!loading && empty" class="no-data">
      暂无数据
    </div>

    <el-carousel
      v-else
      trigger="click"
      style="position:relative;padding: 0 20px;box-sizing: border-box;"
      :height="`${height - 40}px`"
      v-loading="loading"
      element-loading-background="rgba(0, 0, 0, 0.3)"
    >
      <el-carousel-item v-for="item in list" :key="item.id">
        <el-image
          fit="fill"
          :src="item.storePath"
          :style="`height: ${height - 40}px`"
        ></el-image>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import mixin from '../mixin'
import { getPictures } from '@/service/spore'
// import { weekBegin, formatDate } from '@/utlis/date'
import { yearBegin, formatDate } from '@/utlis/date'

export default {
  mixins: [mixin],
  props: { devKey: String },
  data() {
    return {
      loading: false,
      list: []
    }
  },
  computed: {
    device() {
      return this.devKey ? this.spores[0] : ''
      // const key = this.devKey
      // return this.spores.find(s => s.key === key)
    },
    empty() {
      return !(this.list && this.list[0])
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.device) {
        this.list = []
        return
      }
      this.loading = true
      const { data } = await getPictures({
        limit: 5,
        page: 1,
        companyId: this.companyId,
        deviceId: this.device && this.device.id,
        beginDate: yearBegin(),
        endDate: formatDate(undefined, 'YYYY-MM-DD')
        // beginDate: weekBegin(),
        // endDate: formatDate(undefined, 'YYYY-MM-DD')
      })
      this.list = data.pictures
      this.loading = false
    }
  },
  watch: {
    device() {
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.device-picker {
  position: relative !important;
  left: 0 !important;
  top: 0 !important;
  padding-left: 20px;
  padding-top: 8px;
  box-sizing: border-box;
}
.no-data {
  height: calc(100% - 32px);
}
</style>

<style lang="scss">
.card-item.spore {
  .el-carousel__button {
    width: 16px;
  }
  .el-image {
    width: 100%;
  }
  .no-data {
    width: 100%;
    height: calc(100% - 32px);
  }
}
</style>
